<template>
<div>
    <faq hideMenuItems v-if="faqsData && faqsData.length > 0" :faqsData="faqsData" hideSearcher></faq>
</div>
</template>
<script>
import faq from '@/components/views/FAQs'
import healthyHabitsMixin from '@/mixins/healthyHabits.mixin'

export default {
   name: 'healthyHabitsFaqs',
   components: {
    faq
   },
   props: {
   },
   created () {
   },
   mixins: [healthyHabitsMixin],
   data () {
    return {
        faqsData: [
            {
                id: this.$t('faq-table'),
                title: this.$t('faq-table'),
                questions: [
                    {
                        id: this.$t('question-table-1'),
                        question: this.$t('question-table-1'),
                        answer: this.$t('answer-table-1')
                    },
                    {
                        id: this.$t('question-table-2'),
                        question: this.$t('question-table-2'),
                        answer: this.$t('answer-table-2')
                    },
                    {
                        id: this.$t('question-table-3'),
                        question: this.$t('question-table-3'),
                        answer: this.$t('answer-table-3')
                    },
                    {
                        id: this.$t('question-table-4'),
                        question: this.$t('question-table-4'),
                        answer: this.$t('answer-table-4')
                    },
                    {
                        id: this.$t('question-table-5'),
                        question: this.$t('question-table-5'),
                        answer: this.$t('answer-table-5')
                    },
                    {
                        id: this.$t('question-table-6'),
                        question: this.$t('question-table-6'),
                        answer: this.$t('answer-table-6')
                    },
                    {
                        id: this.$t('question-table-8'),
                        question: this.$t('question-table-8'),
                        answer: this.$t('answer-table-8')
                    },
                    {
                        id: this.$t('question-table-7'),
                        question: this.$t('question-table-7'),
                        answer: this.$t('answer-table-7')
                    },
                    {
                        id: this.$t('question-table-10'),
                        question: this.$t('question-table-10'),
                        answer: this.$t('answer-table-10')
                    },
                    // {
                    //     id: this.$t('question-table-9'),
                    //     question: this.$t('question-table-9'),
                    //     answer: this.$t('answer-table-9')
                    // },
                    {
                        id: this.$t('question-table-11'),
                        question: this.$t('question-table-11'),
                        answer: this.$t('answer-table-11')
                    }/* ,
                    {
                        id: this.$t('question-table-12'),
                        question: this.$t('question-table-12'),
                        answer: this.$t('answer-table-12')
                    } */
                ]
            },
            {
                id: this.$t('faq-config'),
                title: this.$t('faq-config'),
                questions: [
                    {
                        id: this.$t('question-config-1'),
                        question: this.$t('question-config-1'),
                        answer: this.$t('answer-config-1')
                    }
                ]
            },
            {
                id: this.$t('faq-statistics'),
                title: this.$t('faq-statistics'),
                questions: [
                    {
                        id: this.$t('question-statistics-1'),
                        question: this.$t('question-statistics-1'),
                        answer: this.$t('answer-statistics-1')
                    },
                    {
                        id: this.$t('question-statistics-2'),
                        question: this.$t('question-statistics-2'),
                        answer: this.$t('answer-statistics-2')
                    },
                    {
                        id: this.$t('question-statistics-3'),
                        question: this.$t('question-statistics-3'),
                        answer: this.$t('answer-statistics-3')
                    },
                    {
                        id: this.$t('question-statistics-4'),
                        question: this.$t('question-statistics-4'),
                        answer: this.$t('answer-statistics-4')
                    }
                ]
            }
        ]
    }
   },
   methods: {
   }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/views/healthy-habits/HealthyHabitsFaqs.vue